import { createSlice } from '@reduxjs/toolkit';
import { auth as coreAuth } from '@sitebuilder/core';
import { ThunkResult } from './index';

// Define the initial state shape
export interface AuthStateShape {
    user: coreAuth.User | null;
}

const initialState: AuthStateShape = {
    user: null,
};

export const actionCreators = {
    setUser: (user: coreAuth.User): ThunkResult<Promise<void>> => {
        return async (dispatch) => {
            dispatch(authActions.setUser(user));
        };
    },
    clearUser: (): ThunkResult<Promise<void>> => {
        return async (dispatch) => {
            dispatch(authActions.clearUser());
        };
    },
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        clearUser: (state) => {
            state.user = initialState.user;
        },
    },
});

export const { setUser, clearUser } = authSlice.actions;
const authActions = authSlice.actions;
export default authSlice.reducer;
